import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { MatDatepickerInputEvent, MatDialog } from "@angular/material";
import * as moment from "moment";
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { TableUtil } from "../admintrademaster/tableUtil";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { EditOfframpDailySummaryDialog } from "./edit-offramp-daily-summary/edit-offramp-daily-summary.component";

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50,
  },
};

@Component({
  selector: "app-offramp-daily-summary",
  templateUrl: "./offramp-daily-summary.component.html",
  styleUrls: ["./offramp-daily-summary.component.css"],
})
export class OfframpDailySummaryComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  oSummaries: any = [];
  summaries: any = [];
  searchValue: string = '';
  statusOptions = ['Pending', 'Reconciled', 'Mismatch'];
  filter: any = {
    page: 1,
    limit: 100,
    status: '',
    fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  prev_disabled = true;
  next_disabled = false;

  myFilter = (d: Date | null): boolean => {
    return true;
  };

  constructor(
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';

          const viewBtn = document.createElement('button');
          viewBtn.type = 'button';
          viewBtn.className = 'btn btn-sm btn-info';
          viewBtn.title = 'View';
          viewBtn.style.marginRight = '5px';
          viewBtn.innerHTML = '<i class="fa fa-eye"></i>';
          viewBtn.onclick = (e) => {
            e.stopPropagation();
            this.displayProperJson(element, 'Offramp Daily Summary');
          };
          container.appendChild(viewBtn);

          const editBtn = document.createElement('button');
          editBtn.type = 'button';
          editBtn.className = 'btn btn-sm btn-primary';
          editBtn.title = 'Edit Actual Closing Balance';
          editBtn.innerHTML = '<i class="fa fa-edit"></i>';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            this.editRecord(element);
          };
          container.appendChild(editBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 120
      },
      {
        headerName: 'Date',
        field: 'date',
        valueFormatter: (params) => params.value ? moment(params.value).format('DD-MMM-YYYY') : '',
        flex: 1
      },
      {
        headerName: 'Total Buy (INR)',
        field: 'totalBuyINR',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1
      },
      {
        headerName: 'Total Received (INR)',
        field: 'totalReceivedINR',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1
      },
      {
        headerName: 'Gross P&L (INR)',
        field: 'grossPnlINR',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1
      },
    
      {
        headerName: 'Profit Share 20% (USDT)',
        field: 'profitShare20USDT',
        valueFormatter: (params) => this.formatNumber(params.value, 4),
        flex: 1.1
      },

      {
        headerName: 'Profit Share 20% (INR)',
        field: 'profitShare20INR',
        valueFormatter: (params) => this.formatNumber(params.value, 4),
        flex: 1.1
      },

      {
        headerName: 'Profit Share 15% (USDT)',
        field: 'profitShare15USDT',
        valueFormatter: (params) => this.formatNumber(params.value, 4),
        flex: 1.1
      },
       {
        headerName: 'Profit Share 15% (INR)',
        field: 'profitShare15INR',
        valueFormatter: (params) => this.formatNumber(params.value, 4),
        flex: 1.1
      },
      {
        headerName: 'Credit Given to Client Today (USDT)',
        field: 'creditGivenUSDT',
        valueFormatter: (params) => this.formatNumber(params.value, 4),
        flex: 1.3
      },
      {
        headerName: 'Delta',
        field: 'deltaRate',
        valueFormatter: (params) => this.formatNumber(params.value, 4),
        flex: 0.8
      },
      {
        headerName: 'Profit Share (5% Delta) (INR)',
        field: 'profitShareDeltaINR',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1.2
      },
      {
        headerName: 'Profit Share (5% Delta) (USDT)',
        field: 'profitShareDeltaUSDT',
        valueFormatter: (params) => this.formatNumber(params.value, 4),
        flex: 1.2
      },
      {
        headerName: 'Total Profit Share (INR)',
        field: 'totalProfitShareINR',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1.1
      },
      {
        headerName: 'P&L after share (INR)',
        field: 'finalNetPnlINR',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1.1
      },
      {
        headerName: 'Daily Expenses (INR)',
        field: 'dailyExpensesINR',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1
      },
      {
        headerName: 'Net P&L After Expenses (INR)',
        field: 'netPnlAfterExpensesINR',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1.2
      },
      {
        headerName: 'Opening Balance (INR)',
        field: 'openingBalanceINR',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1.1
      },
      {
        headerName: 'Expected Closing Balance (INR)',
        field: 'expectedClosingBalanceINR',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1.2
      },
      {
        headerName: 'Actual Closing Balance (INR)',
        field: 'actualClosingBalanceINR',
        valueFormatter: (params) => (params.value === null || params.value === undefined) ? '-' : this.formatNumber(params.value, 2),
        flex: 1.2
      },
      {
        headerName: 'Difference (INR)',
        field: 'differenceINR',
        valueFormatter: (params) => (params.value === null || params.value === undefined) ? '-' : this.formatNumber(params.value, 2),
        flex: 1
      },
      { headerName: 'Status', field: 'status', flex: 0.8 }
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40
    };
  }

  formatNumber(value: any, decimals: number = 2): string {
    if (value === null || value === undefined || isNaN(value)) return '';
    return Number(value).toLocaleString('en-IN', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, defaults.notif);
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  // Client-side quick search only (does NOT call the API)
  applyFilter(filterValue) {
    this.searchValue = filterValue || '';

    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }

    this.applyFilterToLocalData(this.searchValue);
  }

  clearSearch() {
    this.searchValue = '';
    this.applyFilter('');
  }

  applyFilterToLocalData(searchValue: string) {
    if (searchValue) {
      const search = searchValue.toLowerCase();
      this.summaries = this.oSummaries.filter((x: any) => {
        return (x.status && x.status.toLowerCase().includes(search));
      });
    } else {
      this.summaries = this.oSummaries;
    }
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.offrampService.getAllOfframpDailySummary(this.filter).subscribe((response: any) => {
      const list = (response && response.data) || [];
      this.summaries = list;
      this.oSummaries = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
        if (this.searchValue) {
          this.gridApi.setQuickFilter(this.searchValue);
          this.applyFilterToLocalData(this.searchValue);
        } else {
          this.gridApi.setQuickFilter('');
          this.summaries = this.oSummaries;
        }
      }

      this.spinnerService.hide();
      this.prev_disabled = this.filter.page <= 1;
      this.next_disabled = !list || list.length < this.filter.limit;
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch offramp daily summary", defaults.notif);
    });
  }

  displayProperJson(jsonData, eventType) {
    let obj = {
      jsonData: jsonData,
      eventType: eventType || "Offramp Daily Summary"
    }
    this.dialog.open(ProperJsonDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
    });
  }

  resetFilters() {
    this.filter = {
      page: 1,
      limit: 100,
      status: '',
      fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };

    this.searchValue = '';
    if (this.gridApi) {
      this.gridApi.setQuickFilter('');
    }

    this.summaries = this.oSummaries;
    this.getData();
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(EditOfframpDailySummaryDialog, {
      width: '500px',
      data: { record: record, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.getData();
      }
    });
  }

  exportArray() {
    this.spinnerService.show();

    const exportFilter = {
      _csrf: this._csrf,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      status: this.filter.status,
      page: 1,
      limit: 10000
    };

    this.offrampService.getAllOfframpDailySummary(exportFilter).subscribe(
      (response: any) => {
        const list = (response && response.data) || [];
        if (list.length > 0) {
          const exportData = list.map((x: any) => ({
            'Date': x.date ? moment(x.date).format('DD-MMM-YYYY') : '',
            'Total Buy (INR)': x.totalBuyINR,
            'Total Received (INR)': x.totalReceivedINR,
            'Gross P&L (INR)': x.grossPnlINR,
            'Profit Share 10% (USDT)': x.profitShare10USDT,
            'Profit Share 20% (USDT)': x.profitShare20USDT,
            'Profit Share 15% (USDT)': x.profitShare15USDT,
            'Credit Given to Client Today (USDT)': x.creditGivenUSDT,
            'Delta': x.deltaRate,
            'Profit Share (5% Delta) (INR)': x.profitShareDeltaINR,
            'Profit Share (5% Delta) (USDT)': x.profitShareDeltaUSDT,
            'Total Profit Share (INR)': x.totalProfitShareINR,
            'P&L after share (INR)': x.finalNetPnlINR,
            'Daily Expenses (INR)': x.dailyExpensesINR,
            'Net P&L After Expenses (INR)': x.netPnlAfterExpensesINR,
            'Opening Balance (INR)': x.openingBalanceINR,
            'Expected Closing Balance (INR)': x.expectedClosingBalanceINR,
            'Actual Closing Balance (INR)': x.actualClosingBalanceINR,
            'Difference (INR)': x.differenceINR,
            'Status': x.status,
          }));
          TableUtil.exportArrayToExcel(exportData, 'OfframpDailySummary');
        } else {
          this.notifSer.info("Info", "No data available to export", defaults.notif);
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
        this.notifSer.error("Error", "Failed to export data. Please try again.", defaults.notif);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-daily-summary/offramp-daily-summary.component.ts